import { useDidMount } from '@lib/hooks/useDidMount'
import { scrollIntoView } from '@lib/utils/scroll'
import once from 'lodash/once'
import { observer } from 'mobx-react-lite'
import type { FunctionComponent, ReactNode } from 'react'
import { createRef, useEffect } from 'react'

import styles from './payment-funnel.module.scss'

const anchorRef = createRef<HTMLDivElement>()

/**
 * Common layout for payment pages. Includes a section, and a card inside.
 */
export const PaymentFunnel: FunctionComponent<Props> = observer(
    ({ children }) => {
        const mounted = useDidMount()

        useEffect(
            once(() => {
                const anchor = anchorRef.current
                if (!anchor) return
                scrollIntoView(anchor, {
                    behavior: 'smooth',
                    block: 'start',
                })
            }),
            [],
        )

        return (
            <div className={styles.section}>
                <div className={styles.anchor} ref={anchorRef} />
                <div className={styles.card}>{mounted && children}</div>
            </div>
        )
    },
)

type Props = {
    children: ReactNode
}
